import gql from "graphql-tag";
import client from "../apolloClient";

/**
 * The student's subjects (with chapters) for one enrollment.
 *
 * Shared by StudentHome, which loads it on every visit, and the exam switcher,
 * which must refresh it before leaving: ~58 pages read the result back from
 * localStorage("globalsubjects"), and after a switch the student does not
 * always pass through home (the loading screen can send institute students
 * straight to their scheduled exams), so the previous exam's subjects would
 * otherwise linger.
 */
export const FETCH_GET_SUBJECTS = gql`
  query ($student_user_exam_id: Int!) {
    getSubjects(student_user_exam_id: $student_user_exam_id) {
      id
      subject
      practice_percentage
      studentChapters {
        id
        # Read by PracticeCard, which no longer runs its own getSubjects query
        accuracy
        chapter
        topics {
          id
          topic
        }
        class
        attempted_questions
        practice_wrong_answered
        error_questions
        videoAccess
        chapterPreviousquestionsAccess
        enabled
        linkAnalyEnabled
        customExamsEnabled
        errorExamsEnabled
        revMatrialEnabled
        total_questions
      }
    }
  }
`;

/** Store subjects where the pages read them from. */
export function saveGlobalSubjects(subjects) {
  localStorage.setItem("globalsubjects", JSON.stringify(subjects));
}

/**
 * Fetch the subjects of `studentUserExamId` and store them.
 * @returns {Promise<boolean>} true when stored; never rejects.
 */
export function refreshGlobalSubjects(studentUserExamId) {
  return client
    .query({
      query: FETCH_GET_SUBJECTS,
      variables: { student_user_exam_id: parseInt(studentUserExamId) },
      fetchPolicy: "no-cache"
    })
    .then(result => {
      const subjects = result.data && result.data.getSubjects;
      if (!subjects) return false;
      saveGlobalSubjects(subjects);
      return true;
    })
    .catch(error => {
      console.error("getSubjects refresh failed", error);
      return false;
    });
}
